// extracted by mini-css-extract-plugin
export default {"footer":"N_cx","footer_logo":"N_cy","navLinks":"N_cz","column":"N_cB","columnHeading":"N_cC","copyright":"N_cD","socialMediaLinks":"N_cF"};